import { useEffect, useState } from 'react'
import { dynamik } from '../request/dynamik'
import { error } from '../../../Elements/index'
import {companieDetailType} from "../request/getCompaniesType";
import {getCompanies} from "../request/getCompanies";

export const ResponseGetCompanies = () => {
    const [posts, setPosts] = useState<companieDetailType[]>()
    const [isError, setIsError] = useState<boolean>(false)
    useEffect(() => {
        ;(async () => {
            await getCompanies
                .getCompanies()
                .then((data) => {
                    setPosts(data)
                })
                .catch((err) => {
                    error(err)
                    setIsError(true)
                })
        })()
    }, [])

    return isError ? posts : posts
}